import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import {
  AddOrEditSubAdminRequest,
  DeleteSubAdminsRequest,
  ToggleSubAdminStatusRequest,
} from '.././client-sdk/api';

export const useSubAdminApi = () => {
  const subAdminApi = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createSubAdmin = useCallback(
    async (subAdminData: AddOrEditSubAdminRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await subAdminApi.createSubAdminUser(subAdminData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [subAdminApi]
  );

  const getAllSubAdmins = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        const response = await subAdminApi.getAllSubAdmins(
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          searchParam
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [subAdminApi]
  );

  const getToggleStatus = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest = {
          ids: Array.isArray(query.id) ? query.id : [query.id],
          status: query.status,
        };
        const response = await subAdminApi.toggleSubAdminStatus(
          toggleSubAdminStatusRequest
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [subAdminApi]
  );

  const deleteSubAdmin = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const deleteSubAdmins: DeleteSubAdminsRequest = {
          ids: query,
        };
        const response = await subAdminApi.deleteSubAdmins(deleteSubAdmins);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [subAdminApi]
  );

  const editSubAdmin = useCallback(
    async (id: any, subAdminData: AddOrEditSubAdminRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await subAdminApi.editSubAdmin(id, subAdminData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [subAdminApi]
  );
  return {
    createSubAdmin,
    getAllSubAdmins,
    loading,
    error,
    getToggleStatus,
    deleteSubAdmin,
    editSubAdmin,
  };
};
